var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCard',{staticClass:"mb-5",attrs:{"title":"Images","step-component":"ImagingStep"}},[_c('v-container',[_c('SampleImages',{attrs:{"sample-id":_vm.active_sample.id,"read-only":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }